import { useNavigate } from 'react-router-dom';
import { useSelection } from 'src/context';
import { AccordionView } from 'src/features/AccordionView';
import { CreateReportForm } from '~/features';

const CreateReport = () => {
    const navigate = useNavigate();
    const { selected } = useSelection();
    const hasSelections = Object.keys(selected).length > 0;

    return hasSelections ? (
        <div className={`m-auto grid max-w-[1300px] bg-transparent py-3 md:grid-cols-2 md:gap-8 md:px-4`}>
            <div className="bg-grey flex flex-col justify-between p-8 md:rounded-lg">
                <div>
                    <h3 className="pb-8 text-center xl:px-20 xl:text-2xl">
                        Your report will contain the following sections
                    </h3>
                    <AccordionView />
                </div>
                <div className="flex items-end justify-center">
                    <button className="button m-4" onClick={() => navigate('/')}>
                        Edit sections
                    </button>
                </div>
            </div>
            <CreateReportForm />
        </div>
    ) : (
        <div className={`m-auto grid max-w-[1300px] bg-transparent py-3 md:grid-cols-1 md:gap-8 md:px-4`}>
            <div className="bg-grey flex flex-col justify-between p-8 md:rounded-lg">
                <div>
                    <h3 className="pb-8 text-center xl:px-20 xl:text-2xl">
                        Your report will contain the following sections
                    </h3>
                    <p className="p-4 text-center">No selections made yet.</p>
                </div>
                <div className="flex items-end justify-center">
                    <button className="button m-4" onClick={() => navigate('/')}>
                        Edit sections
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateReport;
